// extracted by mini-css-extract-plugin
module.exports = {"container":"RagTagPromotionBanner_container__pXM_2"};